import React from 'react'
import {
  Bullet,
  Bullets,
  Info,
  Page,
  Screenshot,
  Section,
} from '../../components/DocsComponents'
import DocLink from '../../components/DocLink'

const PoliciesAndSOPs = () => (
  <Page
    title="Policies and SOPs"
    intro="Policy and SOP libraries give staff controlled, organisation-wide access to governing documents, with versioning, review dates, and read tracking."
  >
    <Section title="Policy library">
      <Bullets>
        <Bullet>
          Open <DocLink url="/policy-library" text="Policy Library" /> to
          browse policies, then open an individual policy to read its current
          version.
        </Bullet>
        <Bullet>
          Each policy shows its version number, a summary of what changed in
          that version, and its next review date - flagged as overdue once the
          date has passed.
        </Bullet>
        <Bullet>
          Staff use <strong>Mark as Read</strong> to acknowledge a policy.
          The button is only enabled once they have actually opened the policy
          document, and acknowledgements are recorded per version, so
          publishing a new version asks staff to read it again.
        </Bullet>
        <Bullet>
          Governance users can upload a new version, and use{' '}
          <strong>Mark Reviewed</strong> to record a review with no changes
          and set the next review date - overdue policy reviews also surface
          as gaps in the CQC Centre.
        </Bullet>
        <Bullet>
          Policy uploads are <strong>PDF only</strong>, so every policy can be
          read in the built-in viewer on any device. A non-PDF file is
          rejected when it is selected.
        </Bullet>
      </Bullets>
      <Screenshot url="governance/policy-library.png">
        The Policy Library with each policy's version, review date, and read
        status.
      </Screenshot>
    </Section>

    <Section title="Standard Operating Procedures">
      <p>
        Open{' '}
        <DocLink
          url="/standard-operating-procedures"
          text="SOPs and Guidelines"
        />{' '}
        to browse Standard Operating Procedures. SOPs also support
        versioning, review dates, and a mark-as-read acknowledgement, but
        they differ from policies in two ways:
      </p>
      <Bullets>
        <Bullet>
          An SOP can be a <strong>PDF or a video</strong> (mp4, mov, or webm,
          up to 1 GB) - useful for demonstrating a practical procedure rather
          than describing it.
        </Bullet>
        <Bullet>
          SOPs have no open-first rule: staff can mark an SOP as read without
          opening the document first, unlike policies.
        </Bullet>
      </Bullets>
      <Info title="Who can do this?">
        Any signed-in user can read policies and SOPs and mark them as read.
        Adding, editing, reviewing, or deleting them requires the Governance
        team (site administrators always have access). Policies and SOPs are
        not subscription-gated.
      </Info>
    </Section>
  </Page>
)

export default PoliciesAndSOPs
